import React from 'react';
import { useAcquisitionType } from '../../../hooks/stateful/useAcquisitionType';
import type { AcquisitionType } from '../../../support/acquisitionTypes';
import useDownloadsRemaining from './hooks/useDownloadsRemaining';
import DownloadsRemaining from './DownloadsRemaining';

type Props = { eligibleAcquisitionTypes: AcquisitionType[] };

const Container: React.FC<Props> = ({ eligibleAcquisitionTypes }) => {
  const { acquisitionType } = useAcquisitionType();
  const result = useDownloadsRemaining();

  if (!acquisitionType) return null;
  if (!eligibleAcquisitionTypes.includes(acquisitionType)) return null;
  if (!result) return null;

  return <DownloadsRemaining count={result.count} />;
};

export default Container;
